import React from 'react'
import { useIntl } from 'react-intl'
import Image from 'components/Common/Image/Image'
import styled from 'styled-components'
import { rem } from 'polished'

const ImageContainer = styled.div`
  position: relative;
  min-height: ${rem(80)};
  width: 100%;
  aspect-ratio: 2 / 1;
  overflow: hidden;
`

/**
 * @NOTE this is NOT a proper SVG. Due to time constraints we've had to put this temp version for now
 * @TODO replace with proper SVG
 * */
function TuroLogo() {
  const intl = useIntl()

  return (
    <ImageContainer>
      <Image
        image={{ id: 'turo-logo' }}
        fit="center"
        objectFit="contain"
        alt={intl.formatMessage({
          id: 'vk8qoDFRa-fo-WFfU_51',
          defaultMessage: 'Turo logo',
          description: 'Alternative text for the Turo brand logo in the partner promotion section',
        })}
      />
    </ImageContainer>
  )
}

export default TuroLogo
